/** Placeholder when skills are attached but display names are not available yet. */
export const SKILL_ONLY_FALLBACK_MESSAGE = 'Follow the attached skill.'
